<template>
  <div class="book__popover">
    <div class="book__popover-wrapper">
      <div class="book__popover-header">
        <r-title type="subtitle-2">{{ $t("book-sorting:title") }}</r-title>
        <el-button class="r-button simple" type="primary" @click="toggleAll">
          {{ toggleName }}
        </el-button>
      </div>
      <ul class="book__popover-list">
        <li class="book__popover-item" v-for="(i, n) in attributes" :key="n">
          <el-checkbox
            class="r-checkbox"
            size="mini"
            :value="isActive(i)"
            @change="clickHandler(i)"
          />
          <div class="book__popover-item-button" @click="clickHandler(i)">
            <r-text>{{ i.title }}</r-text>
            <r-text type="caption">
              {{ i.type }}
            </r-text>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ["toggleSortTree"],
  data() {
    return {
      activeFields: [],
      attributes: [],
      savingAttributes: false,
      toggleName: ""
    };
  },
  watch: {
    "$store.state.book.activeTable": {
      handler: function() {
        this.setAttributes();
        this.setActiveFields();
      },
      deep: true,
      immediate: true
    },
    activeFields: {
      handler: function(value) {
        this.toggleName = value.length
          ? this.$t("book-sorting:clear-all")
          : this.$t("book-sorting:apply-all");
      },
      deep: true,
      immediate: true
    },
    "$store.state.locale": {
      handler: function() {
        this.toggleName = this.activeFields.length
          ? this.$t("book-sorting:clear-all")
          : this.$t("book-sorting:apply-all");
      }
    }
  },
  methods: {
    isActive(object) {
      const index = this.activeFields.findIndex(
        item => item.title === object.title
      );

      return index > -1;
    },
    clickHandler(object) {
      const index = this.activeFields.findIndex(
        item => item.title === object.title
      );

      if (index > -1) {
        this.activeFields.splice(index, 1);
      } else {
        this.activeFields.push(object);
      }
      this.beforeSaveSortFields();
    },
    toggleAll() {
      if (this.activeFields.length) {
        this.activeFields = [];
      } else {
        this.attributes.forEach(e => {
          this.activeFields.push(e);
        });
      }
      this.toggleName = this.activeFields.length
        ? this.$t("book-sorting:clear-all")
        : this.$t("book-sorting:apply-all");
      this.beforeSaveSortFields();
    },
    setAttributes() {
      this.attributes = [];
      this.$store.state.book.activeTable.fields.forEach(e => {
        if (e.title === "id") return;
        if (
          e.type !== "has_many" &&
          e.type !== "belongs_to" &&
          e.type !== "has_many_through"
        ) {
          let field = {
            title: e.title,
            type: e.type
          };
          field["read_only"] = e.read_only || e.system_field ? true : false;
          this.attributes.push(field);
        }
      });
    },
    setActiveFields() {
      this.activeFields = [];
      this.$store.state.book.activeFields.fields.forEach(e => {
        this.activeFields.push(e);
      });
    },
    beforeSaveSortFields() {
      this.$store.commit("SET_TABLE_LOADING", true);
      const saveFields = function(state) {
        state.saveSortFields();
      };
      setTimeout(saveFields, 500, this);
    },
    async saveSortFields() {
      const activeFields = [];
      this.activeFields.forEach(e => {
        let field = {
          title: e.title,
          type: e.type,
          read_only: e.read_only
        };
        activeFields.push(field);
      });
      this.$store.commit("SET_ACTIVE_FIELDS", {
        fields: activeFields,
        update: true
      });
      const activeTableId = this.$store.state.book.activeTable.id;
      await this.$store.dispatch("SAVE_MODULE_USER_CONFIG", {
        module: "book",
        id: activeTableId
      });
    }
  },
  created() {
    this.setAttributes();
    this.setActiveFields();
    this.toggleName = this.activeFields.length
      ? this.$t("book-sorting:clear-all")
      : this.$t("book-sorting:apply-all");
  }
};
</script>

<style lang="scss"></style>

<i18n>
{
  "ru": {
    "book-sorting:title": "Отображать столбцы",

    "book-sorting:apply-all": "Включить все",
    "book-sorting:clear-all": "Отключить все"
  },
  "en": {
    "book-sorting:title": "Display сolumns",

    "book-sorting:apply-all": "Apply all",
    "book-sorting:clear-all": "Clear all"
  }
}
</i18n>
